import { Service } from "../../../service.js";
import { env } from "../../../env.js";

class TotalizadorClienteService extends Service {
  constructor() {
    super();

    this.url = env.url + "totalizador";
  }

  async get(objetoQueryString) {
    objetoQueryString = {
      ...objetoQueryString,
      "tarefaCliente": true
    }
    const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoQueryString);
    return super.get(`${this.url}/dashboard-cliente` + queryString);
  }
}

export const totalizadorClienteService = new TotalizadorClienteService();
